import React, { useState, useEffect, useLayoutEffect } from 'react';
import {
    Route,
    Redirect,
    useLocation,
    Switch,
    useHistory
} from 'react-router-dom';
import PublicRoutes from './public-routes';
import PrivateRoutes from './private-routes';
import ProfileRoutes from './profile-routes';
import ErrorRoutes from './error-routes';

import Header from '../Header';
import HeaderLoggedOut from '../header-loggedout';
import Footer from '../footer';
import { privRoutes, userRoutes, pubRoutes, adminRoutes, errorPages } from './constants';
import { ToastProvider } from 'react-toast-notifications';
import { ROLES } from '../utils/constants';
import AdminSidebar from '../common/AdminSidebar';
import AdminMain from '../common/AdminMain';
import { useSelector } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Global from '../common/Global';
import SidebarMenu from '../common/SidebarMenu';
import LoggedInContainer from '../templates/LoggedInContainer';
import TopSection from '../common/TopSection';
import { getFirstSegment, isLogin } from '../utils/helper';
import { privateRoutes } from '../utils/rules';
import ErrorHeader from '../common/ErrorHeader';

const AppRoute = () => {
    const location = useLocation();
    const history = useHistory();

    const userInformation = JSON.parse(localStorage.getItem('user'));
    const userID = JSON.parse(localStorage.getItem('loggedin_user'));

    const [isAdminPath, setIsAdminPath] = useState(false);

    const [collapsedMenu, setCollapsedMenu] = useState(false);
    const [toggled, setToggled] = useState(false);

    // exclude - no header|top nav menu
    const exclude = ['/register', '/administration', '/login', '/'];
    const isMessages = location.pathname.indexOf('/messages') == 0;
    const isNotExcluded = !exclude.includes(location.pathname);


    useEffect(() => {
        let isMounted = true;
        let pathname = location.pathname.replace('/', '');
        setIsAdminPath(location.pathname.indexOf('/administration') == 0);
        pathname = pathname.split('?');
        pathname = pathname[0];

        if (pathname === '' && userInformation) {
            pathname = 'home';
        }

        document.getElementById('chat_cont').className = '';
        pathname = pathname.replace(/\s/g, "");
        document.getElementById('chat_cont').classList.add(pathname ? `page-${pathname}` : 'page');

        if (userInformation) {
            $('.main-app').removeClass('is-guest');
            $('.main-app').addClass('is-login');
            $('.main-app').addClass(userInformation.role === 1 ? 'login-pu' : 'login-su');
        } else {
            if ($('.main-app').hasClass('login-pu')) {
                $('.main-app').removeClass('login-pu');
            } else if ($('.main-app').hasClass('login-su')) {
                $('.main-app').removeClass('login-su');
            }

            $('.main-app').removeClass('is-login');
            $('.main-app').addClass('is-guest');
        }

        const firstSegment = getFirstSegment();
        if (privateRoutes.includes(firstSegment) && (!userID || userID <= 0)) {
            window.location = '/';
        }



        if (isLogin() && Object.keys(userInformation).length > 0 && ['register', 'login'].includes(pathname)) {
            history.push('/home');
        }

        return () => {
            isMounted = false;
            setIsAdminPath(false);
        };
    }, [location]);

    const typographyOptions = {
        fontFamily: [
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '-apple-system',
        ].join(',')
    };

    const muiTheme = createTheme({
        palette: {
            mode: 'light',
            primary: {
                main: '#0097fe'
            }
        },
        typography: typographyOptions
    });

    const muiThemeDark = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#0097fe'
            }
        },
        typography: typographyOptions
    });

    const isDarkmode = useSelector(state => state.privaGlobal.darkmode);

    return (
        <>
            <ThemeProvider theme={isDarkmode ? muiThemeDark : muiTheme}>
                <ToastProvider placement="top-center" autoDismiss={false}>
                    {/* REDIRECTS */}
                    <Switch>
                        <Route exact path='/laurenhamden'>
                            <Redirect to='/lozzaa' />
                        </Route>
                    </Switch>

                    {
                        !isLogin()
                            ? <>
                                {
                                    isNotExcluded && window.location.pathname != '/404' ? <HeaderLoggedOut /> : null
                                }
                                <Switch>
                                    {
                                        pubRoutes.map((route, index) => (
                                            <PublicRoutes
                                                key={index}
                                                path={route.path}
                                                exact={route.exact}
                                            >
                                                <route.component />
                                            </PublicRoutes>
                                        ))
                                    }

                                    {
                                        userRoutes.map((route, index) => (
                                            <ProfileRoutes
                                                key={index}
                                                path={route.path}
                                                exact={route.exact}
                                            >
                                                <route.component />
                                            </ProfileRoutes>
                                        ))
                                    }
                                </Switch>
                            </>
                            : (isLogin() && (isNotExcluded || location.pathname === '/') && !isAdminPath && window.location.pathname != '/404')
                                ? <LoggedInContainer
                                    className='loggedIn-container'
                                    topSection={<TopSection />}
                                    menu={<SidebarMenu />}
                                    content={
                                        <React.Fragment>
                                            {
                                                !isAdminPath && <Switch>
                                                    {/* {pubRoutes.map((route, index) => (
                                                        <PublicRoutes
                                                            key={index}
                                                            path={route.path}
                                                            exact={route.exact}
                                                        >
                                                            <route.component />
                                                        </PublicRoutes>
                                                    ))} */}

                                                    {privRoutes.map((route, index) => (
                                                        <PrivateRoutes
                                                            key={index}
                                                            path={route.path}
                                                            exact={route.exact}
                                                        >
                                                            <route.component />
                                                        </PrivateRoutes>
                                                    ))}

                                                    {userRoutes.map((route, index) => (
                                                        <ProfileRoutes
                                                            key={index}
                                                            path={route.path}
                                                            exact={route.exact}
                                                        >
                                                            <route.component />
                                                        </ProfileRoutes>
                                                    ))}
                                                </Switch>
                                            }

                                        </React.Fragment>
                                    }
                                />
                                : null
                    }

                    {
                        userInformation && userInformation.role == ROLES.ADMIN && isAdminPath && isLogin()
                            ? <div className={toggled ? 'toggled' : ''} style={{ display: 'flex', height: '100vh' }}>
                                <AdminSidebar
                                    setCollapsedMenu={setCollapsedMenu}
                                    collapsedMenu={collapsedMenu}
                                    toggled={toggled}
                                    setToggled={setToggled}
                                />
                                <AdminMain
                                    collapsedMenu={collapsedMenu}
                                    setCollapsedMenu={setCollapsedMenu}
                                    toggled={toggled}
                                    setToggled={setToggled}
                                />
                            </div>
                            : null
                    }
                </ToastProvider>

                {
                    !isLogin() && window.location.pathname !== '/404'
                        ? (((isMessages && userInformation && userInformation.role == ROLES.SU) || !isLogin()) ? <Footer /> : null)
                        : null
                }

                {
                    window.location.pathname == '/404'
                        ? <>
                            <ErrorHeader />
                            <Switch>
                                {
                                    errorPages.map((route, index) => (
                                        <ErrorRoutes
                                            key={index}
                                            path={route.path}
                                            exact={route.exact}
                                        >
                                            <route.component />
                                        </ErrorRoutes>
                                    ))
                                }
                            </Switch>
                        </>
                        : null
                }

                <Global />
            </ThemeProvider>
        </>
    );
};

export default AppRoute;
